import { render, staticRenderFns } from "./SetSecurityQuestions.vue?vue&type=template&id=52a5a280&"
import script from "./SetSecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./SetSecurityQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports